import Cookies from 'js-cookie';

/**
 * Persists the light/dark choice made from the masthead toggle. This is a stopgap
 * until there is a real user-preferences screen — at that point the cookie can be
 * replaced by whatever the preferences store uses, and only this module changes.
 */
const THEME_COOKIE = 'cas_theme';
const DARK = 'dark';
const LIGHT = 'light';

/** The class PatternFly v6 looks for on <html> to switch its tokens over. */
const DARK_CLASS = 'pf-v6-theme-dark';

const ONE_YEAR_IN_DAYS = 365;

/** Reads the stored choice. Falls back to light, which is what the app did before. */
export const isDarkThemeStored = (): boolean => Cookies.get(THEME_COOKIE) === DARK;

/** Applies the theme to <html>. Safe to call before React mounts. */
export const applyTheme = (isDark: boolean): void => {
  document.documentElement.classList.toggle(DARK_CLASS, isDark);
};

export const saveThemePreference = (isDark: boolean): void => {
  Cookies.set(THEME_COOKIE, isDark ? DARK : LIGHT, {
    expires: ONE_YEAR_IN_DAYS,
    sameSite: 'strict',
    // Unlike the auth cookies this one is not sensitive, and hard-coding `secure`
    // would stop it persisting when the app is served over plain http in dev.
    secure: window.location.protocol === 'https:'
  });
};
